import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { Profile } from "../../../shared/types/profile";

@Component({
  selector: "app-index-header",
  templateUrl: "./index-header.component.html",
  styleUrls: ["./index-header.component.css"],
})
export class IndexHeaderComponent implements OnInit {
  title = "Support Portal";
  currentProfile: Profile;

  logo: string;

  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  ngOnInit(): void {}

  logout() {
    this.authenticationService.logout();
    this.router.navigate(["/logout"]);
  }
}
